import { Button } from "@mui/material";

export default function ButtonComponent({variant = "contained",color="primary", text, onClick,align,sx = {} }) {
  console.log("sx in button",onClick);
  return (
    <Button
      variant={variant }  // "contained", "outlined", or "text"
      color={color}       // "primary", "secondary", "error", etc.
      align={align}
      onClick={onClick}
      sx = {{ position: "fixed",   // makes it float
        top: 90,          // distance from bottom
        right: 60,           // distance from right
        ...sx    }}
    >
      {text}
    </Button>
  );
}
